import { template as ktemplate, IsKendoMobile } from '@common/navkendo';
import { IIAX_WF_Log_Entries_Sub } from '@common/rwf';
import { INamed } from '@common/utils';
import * as $ from 'jquery';
import { GridColumn, IPageMetaData } from '../nav';

/** custom templates defined in templates.html */
export type TEMPLATE_ID = "DataGridNavPreviewButtonTemplate"
    | "DataGridNavPreviewButtonTemplateInvolved"
    | "DataGridNavSearchPreviewButtonTemplate"
    | "DetailDateMetaTemplate"
    | "DetailCellMetaTemplate"
    | "FullCellTemplate"
    | "DataGridCurrentBreakoutContentTemplate"
    | "DataGridMyInvoiceToolbarTemplate"
    | "DataGridAllInvoiceToolbarTemplate"
    | "DataGridInvolvedInvoiceToolbarTemplate"
    | "DataGridFWFItemsToolbarTemplate"
    | "DataGridFWAllItemsToolbarTemplate";

export function GetCustomKendoTemplate(id: TEMPLATE_ID) {
    if (typeof kendoTemplates === "string") {
        // resolve maaping from string
        const scripts =  $(kendoTemplates).filter("script[id]").toArray();
        scripts.reduce((templates, scriptElement) => {
            templates[scriptElement.id] = scriptElement.innerHTML;
            return templates; }, kendoTemplates = { });
    }
    var result = kendoTemplates[id];
    if (!result) {
        throw new Error(`Custom kendo template "${id}" not found in ` + Object.getOwnPropertyNames(kendoTemplates).join(','));
    }
    return result;
}
var kendoTemplates: string | Partial<Map<TEMPLATE_ID, string>> = require('./templates.html');

/** Get workflow log config columns, shared by controllers */
export function getLogConfigColumns(logMetaData: IPageMetaData<IIAX_WF_Log_Entries_Sub>) {
    var logConfigColumns = <INamed<GridColumn>>{
        "Created": { width: IsKendoMobile() ? 124 : 89, template: CreateDetailDate("Created") },
        "CurrentWFUserName": { width: 184, template: CreateDetailCell(logMetaData, "CurrentWFUserName", "CurrentWFUser") },
        "NextWFUserName": { width: 184, template: CreateDetailCell(logMetaData, "NextWFUserName", "NextWFUser") },
        "CurrentWorkflowStepName": { width: 169, template: CreateDetailCell(logMetaData, "CurrentWorkflowStepName", "CurrentWorkflowPartName") },
        "Remark": <GridColumn>{ width: 300, template: CreateFullCell("Remark") }
    };
    return logConfigColumns;
}

/** Custom Templates Functionality with kendo Template in index.html*/

function CreateFullCell(propname: string) {
    var cacheKey = "FullCellTemplate" + propname;
    return resolveMetaTemplate(cacheKey, "FullCellTemplate", { PropName: propname });
}

/** Create 2 Lined Grid Cell template from MetaData Properties */
function CreateDetailCell(meta: IPageMetaData, mainPropName: string, detailPropName: string) {
    var pMain = meta.PropsByName[mainPropName];
    var pDetail = meta.PropsByName[detailPropName];
    if (!pMain)
        return () => "Property '" + mainPropName + "' not defined";

    if (!pDetail)
        return () => "Property '" + detailPropName + "' not defined";

    var metaProps = {
        Top: {
            Property: (pMain && pMain.Name) || mainPropName,
            Title: (pMain && pMain.Title) || mainPropName
        },
        Sub: {
            Property: (pDetail && pDetail.Name) || detailPropName,
            Title: (pDetail && pDetail.Title) || detailPropName
        }
    };

    var cacheKey = JSON.stringify(metaProps);
    return resolveMetaTemplate(cacheKey, "DetailCellMetaTemplate", metaProps);
}

/** Create Detailled Cell from Date Property */
function CreateDetailDate(propname: string) {
    var cacheKey = "Datetemplate" + propname;
    return resolveMetaTemplate(cacheKey, "DetailDateMetaTemplate", { PropName: propname });
}

function resolveMetaTemplate(cacheKey: string, templateId: TEMPLATE_ID, data: any) {
    var result = templateCache[cacheKey];
    if (!result) {
        var html = GetCustomKendoTemplate(templateId);
        var resolvedtemplate = ktemplate(html)(data);
        result = templateCache[cacheKey] = ktemplate(resolvedtemplate);
    }
    return result;
}
var templateCache = <INamed<(data: any) => string>>{};
